<section
  *transloco="let t"
  class="auth-intro-container"
  [class.error]="submitted && !loading && failed"
  [class.ios-app]="redirect$ | async"
  [class.dialog]="inDialog"
  [class.small-mobileL]="(lessThan$ | async)?.mobileL"
  [class.small-xs]="(lessThan$ | async)?.xs">
  <nav class="dialog-head" *ngIf="inDialog">
    <div aria-hidden="true" class="dynamic-space"></div>
    <button type="button" class="button popsy-button-icon small" (click)="close(true)">
      <popsy-icon-remove class="icon gray-dark"></popsy-icon-remove>
    </button>
  </nav>
  <div class="form">
    <popsy-icon-flat-logo class="logo"></popsy-icon-flat-logo>
    <span class="fixed-space-32" aria-hidden="true"></span>
    <popsy-icon-welcome-illustration
      class="illustration"></popsy-icon-welcome-illustration>
    <span class="fixed-space-32" aria-hidden="true"></span>
    <!-- Errors -->
    <ng-container
      *ngIf="
        (signWithAppleError$ | async) ||
        (signWithGoogleError$ | async) ||
        (signWithFacebookError$ | async)
      ">
      <p class="error" *ngIf="signWithAppleError$ | async">
        {{ t((signWithAppleError$ | async)?.message || '') }}
      </p>
      <p class="error" *ngIf="signWithGoogleError$ | async">
        {{ t((signWithGoogleError$ | async)?.message || '') }}
      </p>
      <p class="error" *ngIf="signWithFacebookError$ | async">
        {{ t((signWithFacebookError$ | async)?.message || '') }}
      </p>
    </ng-container>
    <div aria-hidden="true" class="dynamic-space"></div>
    <!-- Sign with Apple -->
    <ng-container>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <button
        type="button"
        class="apple social-button"
        [disabled]="loading || (signingWithApple$ | async)"
        (click)="onSignWithApple()">
        <div class="icon-container">
          <popsy-icon-apple class="icon"></popsy-icon-apple>
        </div>
        <!-- button text -->
        <span class="message">{{ t('action_continue_with_apple') }}</span>
        <div class="fill-space"></div>
      </button>
    </ng-container>
    <!-- Sign with Google -->
    <ng-container>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <button
        type="button"
        class="google social-button"
        [disabled]="
          loading || (signingWithGoogle$ | async) || !(googleAuthSDKLoaded$ | async)
        "
        (click)="onSignWithGoogle()">
        <div class="icon-container" [class.rtl]="isRtlLayout$ | async">
          <popsy-icon-google class="icon"></popsy-icon-google>
        </div>
        <!-- button text -->
        <span class="message">{{ t('action_continue_with_google') }}</span>
        <div class="fill-space"></div>
      </button>
    </ng-container>
    <!-- Sign with Facebook -->
    <ng-container>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <button
        type="button"
        class="facebook social-button"
        [disabled]="loading || (signingWithFacebook$ | async)"
        (click)="onSignInWithFacebook()">
        <div class="icon-container">
          <popsy-icon-facebook-new class="icon"></popsy-icon-facebook-new>
        </div>
        <!-- button text -->
        <span class="message">{{ t('action_continue_with_facebook') }}</span>
        <div class="fill-space"></div>
      </button>
    </ng-container>

    <div class="link-area" *ngIf="!inDialog">
      <a
        href=""
        [routerLink]="authUrlFragment(nextMode || 'sign-in')"
        [queryParams]="signUpQueryParams$ | async"
        (click)="stopPropagation()"
        >{{ t('action_email') }}</a
      >
    </div>
    <div class="link-area" *ngIf="inDialog">
      <p (click)="changeDialogMode(nextMode || 'sign-in')">{{ t('action_email') }}</p>
    </div>
  </div>
</section>
